import React, { createContext, useState, useContext } from "react";
import PropTypes from "prop-types";

// Cria o contexto
const DateContext = createContext();

// Hook para acessar o contexto mais facilmente
export const useDateContext = () => useContext(DateContext);

// Provedor que encapsula o estado compartilhado
export const DateProvider = ({ children }) => {
  const [selectedStartDate, setSelectedStartDate] = useState();
  const [selectedEndDate, setSelectedEndDate] = useState();
  const [applyMovingAverage, setApplyMovingAverage] = useState(true);
  const [isCurrentDate, setIsCurrentDate] = useState();
  const [realTime, setRealTime] = useState(true);

  return (
    <DateContext.Provider
      value={{
        selectedStartDate,
        setSelectedStartDate,
        selectedEndDate,
        setSelectedEndDate,
        isCurrentDate,
        setIsCurrentDate,
        applyMovingAverage,
        setApplyMovingAverage,
        realTime,
        setRealTime,
      }}
    >
      {children}
    </DateContext.Provider>
  );
};
DateProvider.propTypes = {
  children: PropTypes.any,
};
